import { Box, Stack, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useClient } from '../../../context/ClientContext';
import ClientButton from '../common/Clientbutton';
import ClientFooter from '../common/ClientFooter';
import React from 'react';

const parseClientText = (text) => {
  const lines = text.split('<br/>');
  return lines.map((line, i) => {
    const parts = [];
    let remaining = line;
    const boldRegex = /\*\*(.*?)\*\*/g;
    let match;
    let lastIndex = 0;

    while ((match = boldRegex.exec(line)) !== null) {
      if (match.index > lastIndex) {
        parts.push(line.substring(lastIndex, match.index));
      }
      parts.push(<strong key={`bold-${i}-${match.index}`}>{match[1]}</strong>);
      lastIndex = boldRegex.lastIndex;
    }
    if (lastIndex < line.length) {
      parts.push(line.substring(lastIndex));
    }

    return (
      <React.Fragment key={i}>
        {parts}
        {i !== lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
};

export default function MasterLanding() {
  const navigate = useNavigate();
  const location = useLocation();
  const { landing, clientId } = useClient();
  const [ isAuthenticated, setIsAuthenticated ] = useState( false );
  const { theme } = useClient();

  const { encodedKey } = landing;

  const handleStart = () => {
    localStorage.setItem( 'landing_url', `/${ clientId }-landing?key=${ encodedKey }` );
    localStorage.setItem( `${ clientId }_authenticated`, 'true' );
    localStorage.setItem( `from_${ clientId }`, true );
    navigate( `/${ clientId }-demographics?key=${ encodedKey }` );
  };

  useEffect( () => {
    const authStatus = localStorage.getItem( `${ clientId }_authenticated` );
    localStorage.clear();
    if ( authStatus ) {
      localStorage.setItem( `${ clientId }_authenticated`, authStatus );
    }

    const params = new URLSearchParams( location.search );
    const key = params.get( 'key' );
    const isValid = key === encodedKey;
    setIsAuthenticated( isValid );

    if ( isValid ) {
      localStorage.setItem( `${ clientId }_authenticated`, 'true' );
    } else {
      console.error( 'Auth failed' );
    }
  }, [ location, encodedKey, clientId ] );

  if ( !isAuthenticated ) {
    return (
      <Box sx={ {
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white'
      } }>
        <Typography sx={ {
          fontSize: '20px',
          fontWeight: 500,
          textAlign: 'center',
          fontFamily: 'Poppins',
          padding: 3
        } }>
          Authorization required. Please use a valid authentication link to access this page.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={ {
      width: '100%',
      height: {
        xs: "90vh", lg: "100vh", sm: "100vh", md: "100vh"
      },
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'white',
      overflowX: 'hidden',
      overflowY: 'auto'
    } }>
      <Stack sx={ {
        width: {
          xs: '100%',
          sm: '390px',
          md: '100%'
        },
        maxWidth: {
          xs: '390px',
          sm: '390px',
          md: 'none'
        },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        px: {
          xs: 6,
          sm: 4,
          md: 4
        }
      } }>
        <Stack sx={ {
          width: '100%',
          maxWidth: {
            md: '1200px'
          },
          mt: {
            xs: '100px',
            sm: '170px',
            md: '170px'
          },
          alignItems: 'center'
        } }>
          <Typography
            sx={ {
              fontSize: {
                xs: '28px',
                sm: '35px'
              },
              fontWeight: 700,
              lineHeight: {
                xs: '30px',
                sm: '35px'
              },
              textAlign: 'center',
              fontFamily: 'Poppins'
            } }
          >
            {landing?.headerText}
          </Typography>

          <Stack sx={ {
            width: '100%',
            maxWidth: '390px',
            alignItems: 'center',
            spacing: 2,
            mt: 3
          } }>
            <Typography sx={ {
              pt: {
                xs: 2,
                sm: '27px'
              },
              textAlign: 'center',
              fontWeight: 400,
              fontSize: '15px',
              lineHeight: '20px',
              fontFamily: 'Poppins',
              mb: 2
            } }>
              {landing?.subText}
            </Typography>

            <Typography sx={ {
              textAlign: 'center',
              fontWeight: 400,
              fontSize: '15px',
              lineHeight: '20px',
              fontFamily: 'Poppins',
              mb: 3
            } }>
              {landing?.timerText}
            </Typography>

            <Typography sx={ {
              textAlign: 'center',
              fontWeight: 400,
              fontSize: '15px',
              lineHeight: '20px',
              fontFamily: 'Poppins',
              mb: 3
            } }>
              {parseClientText(landing?.clientText || '')}
            </Typography>

            <ClientButton
              text="Take the Assessment"
              onClick={ handleStart }
              backgroundColor={ theme.primaryColor }
              sx={ {
                maxWidth: "320px",
                width: "100%",
                marginTop: { xs: '4px', sm: '30px', md: '20px', lg: "10px" },
              } }
            />
          </Stack>
        </Stack>

        <Stack sx={ {
          position: 'absolute',
          bottom: {
            xs: '20px',
            sm: '20px'
          },
          left: '50%',
          transform: 'translateX(-50%)',
          width: {
            xs: '90%',
            sm: 'auto'
          }
        } }>
          <ClientFooter
            footerTitle={ theme.footerTitle }
            logo={ theme.logo }
          />
        </Stack>
      </Stack>
    </Box>
  );
}
